var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimezone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.875,0,0,0.875,25,25)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 200,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "21.43px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200,25L200,375",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 12
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.03293,0,0,1,-6.58535,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200,25C200,25 295.021,59.31 292.272,200C289.523,340.69 200,375 200,375",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "18.44px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200,200L375,200",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 12
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.419,265.259C359.419,265.259 311.203,285.768 200,291.434",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 12
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,115.426C200,115.426 287.212,118.161 359.419,137.995",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 12
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,200L52.279,200",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 12
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.484,107.363L78.004,123.571",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 12
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.363,50.701L128.863,72.932",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 12
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.826,287.422L74.461,272.276",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 12
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.363,350.305L128.863,329.091",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 12
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,200L107.023,220.283",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 12
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,200L107.023,83.132",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 12
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimezone);
export default __webpack_public_path__ + "static/media/timezone.3532fa9e3cfce524648dd9665b80e76b.svg";
export { ForwardRef as ReactComponent };